import { IUser } from '@shared';

export const getAssignedTrainerIds = (user: IUser): string[] => {
  const ids = new Set((user.trainerIds ?? []).filter((id) => !!id));
  if (user.trainerId) {
    ids.add(user.trainerId);
  }
  return Array.from(ids);
};

export const isAssignedToTrainer = (user: IUser, trainerId: string): boolean => getAssignedTrainerIds(user).includes(trainerId);

export const getTrainerNames = (users: IUser[], trainerIds: string[]): string =>
  trainerIds
    .map((trainerId) => users.find((user) => user.id === trainerId))
    .filter((trainer): trainer is IUser => !!trainer)
    .map((trainer) => trainer.firstName || trainer.email)
    .join(', ');
